import axios from 'axios';

import cfac22 from '../cfac22';

export default function findWalletVoucher(voucherId) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      get(cfac22('API_HOST_V2') + '/vouchers/findWalletVoucher?voucherId=' + voucherId, {
        headers: { 'Full-Url': window.location.href }, withCredentials: true
      }).
      then((result) => {
        //console.log("RESULTADO API FIND VOUCHER ===>: ", result);
        resolve(result.data);
      }).
      catch((error) => {
        //console.log("ERRO API FIND VOUCHER ===>: ", error);
        return reject(error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
